<template>
  <div>
    <Dialog
      :key="roleFormKey"
      :visible.sync="rolesForm1"
      :style="{ width: '900px', overflowY: 'auto' }"
      header="Role Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="roleName">Role Name*</label>
          <InputText
            id="roleName"
            v-model.trim="role.roleName"
            required="true"
            type="roleName"
            autofocus
            :class="{ 'p-invalid': submitted && !role.roleName }"
            :disabled="disabledArr.includes('roleName')"
          />
          <small class="p-invalid" v-if="submitted && !role.roleName"
            >Role Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="active">Make Active</label>
          <br />
          <InputSwitch
            v-model="role.active"
            autofocus
            :disabled="disabledArr.includes('active')"
          />
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="$emit('close')"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="save"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import RoleService from "@/service/RoleService";

import { sendRole } from "../sendRequest";

export default {
  created() {
    this.setupComponent();
  },
  props: {
    rolesForm: {
      required: true,
      type: Boolean
    },
    reloadForm: {
      required: false,
      type: Number
    },
    disabledArr: {
      required: true,
      type: Array
    },
    roleToEdit: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    roleService: new RoleService(),
    roleFormKey1: 0,
    submitted: false,
    sendingRequest: false,
    role: {
      active: true
    }
  }),
  computed: {
    roleFormKey: {
      set(val) {
        this.roleFormKey1++;
      },
      get() {
        //
        return "roleFormKey-" + this.roleFormKey1.toString();
      }
    },
    rolesForm1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.rolesForm;
      }
    }
  },
  watch: {
    rolesForm(val) {
      this.roleFormKey = this.roleFormKey1 + 1;
    },
    reloadForm(val) {
      this.setupComponent();
    }
  },
  methods: {
    setupComponent() {
      this.submitted = false;
      this.sendingRequest = false;
      this.role = {
        active: true
      };

      if (this.roleToEdit && this.roleToEdit.id) {
        this.role = this.roleToEdit;
      }
    },
    save() {
      //
      this.submitted = true;
      this.sendingRequest = true;

      sendRole(this, "RolesForm.vue");
    }
  }
};
</script>

<style scoped></style>
